module.exports = "<div class=q-marg-all-xl> <div class=q-marg-vert-md>There are <span class=q-boldest>{%- shpPackageCount %} packages</span> related to the original order ID.</div> <div class=q-marg-vert-md>Would you like to view a summary of all related packages? You will be redirected from this detail page.</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/proofOfDelivery/podPackageDetailsScreen/html/modalOrderBody.html
// module id = 1380
// module chunks = 1